import React from "react";
import { FormProvider } from "react-hook-form";
import { Edit } from "@refinedev/mui";

import { DiscountForm } from "@modules/discounts/components/DiscountForm";
import { useDiscountEditForm } from "./controller";

export const DiscountEdit = React.memo(() => {
  const { methods, handleSubmit, mutateAsync, isPending, formLoading, id } = useDiscountEditForm();

  return (
    <Edit
      recordItemId={id}
      saveButtonProps={{
        onClick: handleSubmit(mutateAsync as any),
        loading: isPending,
      }}
      isLoading={formLoading}
    >
      <FormProvider {...methods}>
        <DiscountForm />
      </FormProvider>
    </Edit>
  );
});
